import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const store = new Vuex.Store({
    namespaced: true,
    state: {
        csrfToken: null, // Initialize csrfToken to null
    },
    mutations: {
        setCsrfToken(state, token) {
            state.csrfToken = token; // Update csrfToken with the provided token
        },
    },
});

export default store;
